import React from 'react';
import '../styles/jumpingdots.scss';

const JumpingDots = () => {
  return (
    <div className="jumping-dots">
      <span className="dot" />
      <span className="dot" />
      <span className="dot" />
    </div>
  );
};

export default JumpingDots;
